module.exports = "/_next/static/images/logo--full-2e2f8f09beaaa89f50715e17b0444311.png";